import styled from "styled-components";

export const CarouselContainer = styled.div`
  position: relative;
`;
export const CarouselHeader = styled.div`
  padding: 0 0 8px 164px;
  span {
    user-select: none;
    font-size: 24px;
  }
  .CarouselHeader-txtEmpty {
    font-style: italic;
    font-size: 20px;
  }
`;

export const CarouselGrid = styled.div`
  display: grid;
  width: max-content;
  height: ${(props) => (props.minimize ? "106px" : "286px")};
  grid-template-rows: ${(props) =>
    props.cantidadFilasGrid && `repeat(${props.cantidadFilasGrid}, 1fr)`};
  transition: transform 0.3s ease-in-out;
  grid-auto-flow: column;
  padding-left: 168px;
  grid-row-gap: 14px;
  grid-column-gap: 14px;
`;
export const CarouselItem = styled.div`
  display: flex;
  justify-content: ${(props) => (props.opcDelete ? `auto` : `center`)};
  align-items: center;
  text-align: center;
  width: 516px;
  height: 46px;
  border-radius: 12px;
  cursor: ${(props) => (props.opcDelete ? `auto` : `pointer`)};
  background: ${(props) =>
    props.opcDelete
      ? `var(--color-primary)`
      : `var(
    --Grandiente-cards,
    linear-gradient(258deg, #027bc0 18.65%, #004b76 86.55%)
  )`};

  box-shadow: 3px 7px 11px 0px rgba(0, 0, 0, 0.25);
  color: var(--color-white);
  font-size: 18px;
  user-select: none;
  .Carousel-Cruz {
    font-weight: bold;
    padding: 0 20px 0 16px;
    cursor: pointer;
  }
`;
export const FlechasContainer = styled.div``;
export const ArrowButtonContainer = styled.div`
  margin-top: ${(props) => (props.minimize ? "8px" : "18px")};
`;
export const ArrowButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) =>
    props.disabled
      ? "var(--color-grey65)"
      : props.opcDelete
      ? "var(--color-primary)"
      : "var(--color-latex30)"};
  cursor: pointer;
  color: var(--color-white);
  font-size: 24px;
  border-radius: 50%;
  width: 52px;
  height: 52px;
  position: absolute;
  top: ${(props) => `${props.top}px`};
  right: ${(props) => `${props.right}px`};
  left: ${(props) => `${props.left}px`};
  bottom: ${(props) => `${props.bottom}px`};
  z-index: 1;
  user-select: none;
`;
